import React, { ReactNode, useContext } from "react";
import { RoomContext } from "App/context";
import Constellation from "common/components/Constellation";
import { DraftCharacter } from "types/Draft/type";
import { PlayersNumber } from "types/Room/type";

type CharacterBadgesProps = {
  character: DraftCharacter;
  side: "player1" | "player2";
  // Ce qui s'affiche à la place de la constellation (la grille peut montrer des points).
  format?: (constellation: number) => ReactNode;
  hideLevel?: boolean;
};

// Capitaine sur la première ligne, coéquipier sur la seconde ; le niveau à droite de la constellation.
const SLOTS = {
  player1: [
    ["player1", "player1Lvl"],
    ["player3", "player3Lvl"],
  ],
  player2: [
    ["player2", "player2Lvl"],
    ["player4", "player4Lvl"],
  ],
} as const;

/*
  Badges d'un perso pour un camp : constellation et niveau (au-delà de 90) de chaque joueur qui
  le possède. En 1vs1, le pool les porte déjà (box d'équipe figée) ; en 2vs2, chaque joueur de
  l'équipe a les siens, lus dans sa propre box.
*/
const CharacterBadges = (props: CharacterBadgesProps) => {
  const { character, side, format = (c) => c, hideLevel = false } = props;
  const { params, player1, player2, player3, player4 } =
    useContext(RoomContext);
  const isPlayer1 = side === "player1";

  const owned: Array<{ constellation?: number; lvl?: number } | undefined> =
    params.playersNumber === PlayersNumber._2vs2
      ? (isPlayer1 ? [player1, player3] : [player2, player4]).map((player) =>
          player?.box?.find((c) => c.name === character.name),
        )
      : [
          {
            constellation: isPlayer1
              ? character.p1Constellation
              : character.p2Constellation,
            lvl: isPlayer1 ? character.p1Level : character.p2Level,
          },
        ];

  return (
    <>
      {owned.map((owner, index) => {
        if (owner?.constellation === undefined) return null;
        const [slot, levelSlot] = SLOTS[side][index];
        const showLevel =
          !hideLevel && owner.lvl !== undefined && owner.lvl > 90;
        return (
          <React.Fragment key={slot}>
            <Constellation player={slot} joined={showLevel}>
              {format(owner.constellation)}
            </Constellation>
            {showLevel && (
              <Constellation player={levelSlot}>{owner.lvl}</Constellation>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CharacterBadges;
